var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 182,
    viewBox: "0 0 144 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.015 151.536C124.015 157.355 100.73 162.072 72.0058 162.072C43.2847 162.072 20 157.355 20 151.536C20 145.717 43.2847 141 72.0058 141C100.73 141 124.015 145.717 124.015 151.536Z",
    fill: "black",
    fillOpacity: 0.0676355
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.2062 37.2072C36.2062 37.2072 34.4544 31.4528 35.4267 22.2822C36.4019 13.1115 40.4019 1.01378 46.4807 0.038269C52.5566 -0.937243 65.0004 17.0139 64.8135 22.2822C64.6237 27.5505 36.2062 37.2072 36.2062 37.2072Z",
    fill: "#FDFDFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.247 37.2074C38.247 37.2074 36.5886 32.417 37.5083 24.7827C38.4309 17.1484 42.2207 7.07744 47.9784 6.26524C53.736 5.45334 65.5229 20.3971 65.3448 24.7827C65.1667 29.1686 38.247 37.2074 38.247 37.2074Z",
    fill: "#F5F2E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.2767 33.2056C41.2767 33.2056 40.1877 29.6249 40.792 23.9185C41.3964 18.2124 43.8869 10.6848 47.6679 10.0775C51.449 9.4705 59.192 20.6405 59.0752 23.9185C58.9585 27.1966 41.2767 33.2056 41.2767 33.2056Z",
    fill: "#E05A50"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.652 37.2072C113.652 37.2072 115.404 31.4528 114.432 22.2822C113.457 13.1115 109.457 1.01378 103.381 0.038269C97.302 -0.937243 84.8582 17.0139 85.045 22.2822C85.2348 27.5505 113.652 37.2072 113.652 37.2072Z",
    fill: "#FDFDFD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111.612 37.2074C111.612 37.2074 113.273 32.417 112.35 24.7827C111.428 17.1484 107.638 7.07744 101.88 6.26524C96.1225 5.45334 84.3356 20.3971 84.5137 24.7827C84.6918 29.1686 111.612 37.2074 111.612 37.2074Z",
    fill: "#F5F2E9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.581 33.2056C108.581 33.2056 109.673 29.6249 109.066 23.9185C108.461 18.2124 105.971 10.6848 102.19 10.0775C98.4088 9.4705 90.6658 20.6405 90.7826 23.9185C90.8993 27.1966 108.581 33.2056 108.581 33.2056Z",
    fill: "#E05A50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.215 83.0625L33.7126 83.1579C33.7126 83.1579 24.7578 95.5884 24.7578 119.302C24.7578 133.998 27.8994 144.581 30.2877 150.505C31.6279 153.831 34.895 156.019 38.5359 156.019H112.051C115.202 156.019 118.042 154.155 119.245 151.295C121.663 145.549 125.099 134.676 125.099 119.302C125.099 95.5884 116.215 83.0625 116.215 83.0625Z",
    fill: "#F9F9F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.471 86.0805C117.471 103.104 98.2626 124.57 74.5692 124.57C50.8728 124.57 31.6641 103.104 31.6641 86.0805C31.6641 69.0575 50.8728 55.2578 74.5692 55.2578C98.2626 55.2578 117.471 69.0575 117.471 86.0805Z",
    fill: "#AED6AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.4459 86.4812C22.8896 93.2024 19.3218 105.263 29.275 116.695C39.2313 128.128 47.7568 132.211 55.9145 123.953C63.2838 116.493 60.9159 110.163 50.1772 101.792C39.4386 93.4222 35.7042 77.7028 28.4459 86.4812Z",
    fill: "#F5F2E9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.9662 85.5873C24.0698 91.5077 20.9282 102.131 29.6961 112.201C38.464 122.271 45.9735 125.867 53.1589 118.593C59.6494 112.023 57.5647 106.447 48.1049 99.0741C38.6479 91.7014 35.3603 77.8549 28.9662 85.5873Z",
    fill: "#F9F9F9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2376 126.71C48.2376 126.71 45.2186 125.953 44.5938 123.511C43.9719 121.07 46.8828 123.031 48.2376 126.71Z",
    fill: "#E4A973"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.897 123.952C51.897 123.952 48.8459 123.334 48.1072 120.923C47.3685 118.513 50.37 120.34 51.897 123.952Z",
    fill: "#E4A973"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2045 120.389C55.2045 120.389 52.1154 120.001 51.1928 117.652C50.2731 115.303 53.4059 116.901 55.2045 120.389Z",
    fill: "#E4A973"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3134 116.393C58.3134 116.393 55.2681 115.756 54.544 113.341C53.8229 110.926 56.8127 112.771 58.3134 116.393Z",
    fill: "#E4A973"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.73 86.4812C125.286 93.2024 128.854 105.263 118.901 116.695C108.945 128.128 100.419 132.211 92.2613 123.953C84.892 116.493 87.2599 110.163 97.9985 101.792C108.737 93.4222 112.472 77.7028 119.73 86.4812Z",
    fill: "#F5F2E9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.21 85.5873C124.106 91.5077 127.248 102.131 118.48 112.201C109.712 122.271 102.202 125.867 95.0169 118.593C88.5264 112.023 90.6111 106.447 100.071 99.0741C109.528 91.7014 112.815 77.8549 119.21 85.5873Z",
    fill: "#F9F9F9"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.9382 126.71C99.9382 126.71 102.957 125.953 103.582 123.511C104.204 121.07 101.293 123.031 99.9382 126.71Z",
    fill: "#E4A973"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.2788 123.952C96.2788 123.952 99.3299 123.334 100.069 120.923C100.807 118.513 97.8058 120.34 96.2788 123.952Z",
    fill: "#E4A973"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.9713 120.389C92.9713 120.389 96.0603 120.001 96.983 117.652C97.9027 115.303 94.7698 116.901 92.9713 120.389Z",
    fill: "#E4A973"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.8624 116.393C89.8624 116.393 92.9077 115.756 93.6317 113.341C94.3529 110.926 91.3631 112.771 89.8624 116.393Z",
    fill: "#E4A973"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9312 68.7217H113.41C116.052 68.7217 118.195 71.4176 118.195 74.7433V81.4838C118.195 95.9605 31.6641 95.9339 31.6641 81.4838V74.7433C31.6641 71.4176 33.8071 68.7217 36.4495 68.7217H74.9312Z",
    fill: "#E05A50"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.9317 79.2187C100.722 79.2187 118.24 78.477 120.964 65.2088C123.691 51.9403 113.373 28.3308 103.489 22.8673C93.6062 17.4038 74.9317 17.7942 74.9317 17.7942C74.9317 17.7942 56.2544 17.4038 46.3711 22.8673C36.4879 28.3308 26.1726 51.9403 28.8967 65.2088C31.6208 78.477 49.139 79.2187 74.9317 79.2187Z",
    fill: "#F5F2E9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4786 72.4453C100.268 72.4453 117.787 71.7879 120.511 60.0285C123.238 48.2688 112.919 27.344 103.036 22.5019C93.1531 17.6597 74.4786 18.0054 74.4786 18.0054C74.4786 18.0054 55.8012 17.6597 45.918 22.5019C36.0348 27.344 25.7195 48.2688 28.4436 60.0285C31.1677 71.7879 48.6859 72.4453 74.4786 72.4453Z",
    fill: "#F9F9F9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7773 41.2087C47.7773 41.2087 49.5642 33.0136 57.0941 33.2085C64.627 33.4037 64.8138 40.2329 64.8138 40.2329",
    fill: "#F9F9F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.9264 56.667C70.4551 54.3578 72.2873 52.1949 74.7885 51.9534C77.3503 51.706 79.9575 53.224 80.0523 55.9245C80.0731 56.5204 81.0205 56.5232 80.9997 55.9245C80.8898 52.8122 78.0513 50.8547 75.0234 51.0084C71.9955 51.1624 69.6574 53.604 69.0131 56.4202C68.8805 57.0022 69.7938 57.2509 69.9264 56.667Z",
    fill: "#E05A50"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.079 41.2087C102.079 41.2087 100.293 33.0136 92.7627 33.2085C85.2298 33.4037 85.043 40.2329 85.043 40.2329",
    fill: "#F9F9F9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.9856 44.3199C38.2513 45.3607 40.5141 46.4012 42.7797 47.442C43.2907 47.6755 43.7345 46.9193 43.2235 46.6836C40.9579 45.6432 38.6922 44.6024 36.4265 43.5619C35.9184 43.328 35.4717 44.0846 35.9856 44.3199Z",
    fill: "#C6C3B8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.796 54.3147C36.4092 53.8596 39.0252 53.4042 41.6413 52.9491C42.196 52.8525 41.9595 52.0061 41.4077 52.1023C38.7917 52.5575 36.1785 53.0129 33.5625 53.4683C33.0077 53.5646 33.2442 54.411 33.796 54.3147Z",
    fill: "#C6C3B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.5197 61.8603C38.5314 60.2181 40.543 58.5758 42.5576 56.9336C42.9956 56.5768 42.3708 55.959 41.9387 56.3128C39.9241 57.9551 37.9124 59.5973 35.8978 61.2396C35.4627 61.5963 36.0846 62.2142 36.5197 61.8603Z",
    fill: "#C6C3B8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.43 43.562C111.164 44.6025 108.898 45.6432 106.633 46.6837C106.122 46.919 106.565 47.6759 107.076 47.4421C109.342 46.4013 111.608 45.3608 113.871 44.32C114.384 44.085 113.938 43.3278 113.43 43.562Z",
    fill: "#C6C3B8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.298 53.4683C113.684 53.0128 111.068 52.5574 108.452 52.1023C107.9 52.0063 107.664 52.8522 108.219 52.949C110.835 53.4042 113.451 53.8596 116.064 54.3147C116.616 54.4107 116.852 53.5648 116.298 53.4683Z",
    fill: "#C6C3B8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.961 61.2396C111.947 59.5973 109.935 57.9551 107.92 56.3128C107.488 55.959 106.863 56.5766 107.301 56.9336C109.316 58.5759 111.328 60.2181 113.342 61.8604C113.774 62.2142 114.399 61.5967 113.961 61.2396Z",
    fill: "#C6C3B8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9565 157.502C34.8674 157.502 32.4849 154.743 32.9638 151.684C33.9068 145.687 37.4251 137.209 49.7871 137.209C62.5346 137.209 65.2995 146.225 65.7258 152.238C65.9273 155.085 63.6645 157.502 60.8178 157.502H37.9565Z",
    fill: "#F5F2E9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.333 157.502C115.124 157.502 117.285 155.04 116.914 152.267C116.108 146.255 112.777 137.209 100.009 137.209C87.4395 137.209 84.5753 145.974 84.0877 151.983C83.8454 154.952 86.1636 157.502 89.133 157.502H112.333Z",
    fill: "#F5F2E9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.9565 154.575C34.8674 154.575 32.4849 151.816 32.9638 148.757C33.9068 142.76 37.4251 134.282 49.7871 134.282C62.5346 134.282 65.2995 143.299 65.7258 149.311C65.9273 152.159 63.6645 154.575 60.8178 154.575H37.9565Z",
    fill: "#F9F9F9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.333 154.575C115.124 154.575 117.285 152.113 116.914 149.34C116.108 143.328 112.777 134.282 100.009 134.282C87.4395 134.282 84.5753 143.047 84.0877 149.057C83.8454 152.025 86.1636 154.575 89.133 154.575H112.333Z",
    fill: "#F9F9F9"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.2304 153.794C39.2304 153.794 37.0494 151.843 37.6012 149.502C38.1559 147.16 39.718 150.087 39.2304 153.794Z",
    fill: "#E4A973"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9588 153.794C44.9588 153.794 42.7778 151.843 43.3325 149.502C43.8873 147.16 45.4493 150.087 44.9588 153.794Z",
    fill: "#E4A973"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.0369 153.794C51.0369 153.794 48.8559 151.843 49.4107 149.502C49.9654 147.16 51.5275 150.087 51.0369 153.794Z",
    fill: "#E4A973"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.908 153.794C57.908 153.794 55.727 151.843 56.2818 149.502C56.8365 147.16 58.3985 150.087 57.908 153.794Z",
    fill: "#E4A973"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.562 153.794C110.562 153.794 112.743 151.843 112.191 149.502C111.636 147.16 110.074 150.087 110.562 153.794Z",
    fill: "#E4A973"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.832 153.794C104.832 153.794 107.013 151.843 106.459 149.502C105.904 147.16 104.342 150.087 104.832 153.794Z",
    fill: "#E4A973"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.7541 153.794C98.7541 153.794 100.935 151.843 100.38 149.502C99.8257 147.16 98.2636 150.087 98.7541 153.794Z",
    fill: "#E4A973"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.887 153.794C91.887 153.794 94.068 151.843 93.5132 149.502C92.9585 147.16 91.3964 150.087 91.887 153.794Z",
    fill: "#E4A973"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7997 96.9649C88.7997 104.643 82.5895 110.867 74.9311 110.867C67.2698 110.867 61.0625 104.643 61.0625 96.9649C61.0625 89.2867 67.2698 83.0625 74.9311 83.0625C82.5895 83.0625 88.7997 89.2867 88.7997 96.9649Z",
    fill: "#E4A973"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7997 96.9649C88.7997 104.643 82.534 109.501 74.8727 109.501C67.2143 109.501 61.0625 104.643 61.0625 96.9649C61.0625 89.2867 67.2698 83.0625 74.9311 83.0625C82.5895 83.0625 88.7997 89.2867 88.7997 96.9649Z",
    fill: "#F7E390"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.728 99.3977C78.728 101.499 77.0287 103.203 74.9323 103.203C72.836 103.203 71.1367 101.499 71.1367 99.3977C71.1367 97.2962 72.836 95.5928 74.9323 95.5928C77.0287 95.5928 78.728 97.2962 78.728 99.3977Z",
    fill: "#9E6C44"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8293 99.3981H62.0278C60.6935 99.3981 59.6016 98.3032 59.6016 96.9653C59.6016 95.6272 60.6935 94.5322 62.0278 94.5322H87.8293C89.1665 94.5322 90.2585 95.6272 90.2585 96.9653C90.2585 98.3032 89.1665 99.3981 87.8293 99.3981Z",
    fill: "#E4A973"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7736 98.7155H61.9692C60.6349 98.7155 59.543 97.6205 59.543 96.2824C59.543 94.9442 60.6349 93.8496 61.9692 93.8496H87.7736C89.1079 93.8496 90.1999 94.9442 90.1999 96.2824C90.1999 97.6205 89.1079 98.7155 87.7736 98.7155Z",
    fill: "#F7E390"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4929 94.5812C69.3002 94.5812 77.1046 94.5812 84.9119 94.5812C86.0272 94.5812 87.1426 94.5812 88.2579 94.5812C88.8214 94.5812 88.8214 93.7031 88.2579 93.7031C80.4506 93.7031 72.6433 93.7031 64.836 93.7031C63.7236 93.7031 62.6083 93.7031 61.4929 93.7031C60.9294 93.7031 60.9294 94.5812 61.4929 94.5812Z",
    fill: "#E4A973"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7817 42.0697L75.9686 44.2218C75.4576 44.828 74.3978 44.828 73.8868 44.2218L72.0737 42.0697C71.4664 41.35 72.0737 40.3496 73.116 40.3496H76.7423C77.7817 40.3496 78.389 41.35 77.7817 42.0697Z",
    fill: "#E05A50"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.8535 89.0134C82.8535 90.1988 81.8929 91.1597 80.7105 91.1597C79.528 91.1597 78.5703 90.1988 78.5703 89.0134C78.5703 87.8281 79.528 86.8672 80.7105 86.8672C81.8929 86.8672 82.8535 87.8281 82.8535 89.0134Z",
    fill: "#FFFFFE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M64 41.6809C64 45.8759 60.4183 50 56 50C51.5817 50 48 45.8759 48 41.6809C48 37.4858 51.5817 33 56 33C60.4183 33 64 37.4858 64 41.6809Z",
    fill: "#F7E390"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M62 41.6383C62 44.8462 59.3137 48 56 48C52.6863 48 50 44.8462 50 41.6383C50 38.4303 52.6863 35 56 35C59.3137 35 62 38.4303 62 41.6383Z",
    fill: "#0A0B09"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M59 39.5532C59 40.787 58.1046 42 57 42C55.8954 42 55 40.787 55 39.5532C55 38.3194 55.8954 37 57 37C58.1046 37 59 38.3194 59 39.5532Z",
    fill: "#F9F9F9"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M84 41.6809C84 45.8759 87.5817 50 92 50C96.4183 50 100 45.8759 100 41.6809C100 37.4858 96.4183 33 92 33C87.5817 33 84 37.4858 84 41.6809Z",
    fill: "#F7E390"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M86 41.6383C86 44.8462 88.6863 48 92 48C95.3137 48 98 44.8462 98 41.6383C98 38.4303 95.3137 35 92 35C88.6863 35 86 38.4303 86 41.6383Z",
    fill: "#0A0B09"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M89 39.5532C89 40.787 89.8954 42 91 42C92.1046 42 93 40.787 93 39.5532C93 38.3194 92.1046 37 91 37C89.8954 37 89 38.3194 89 39.5532Z",
    fill: "#F9F9F9"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 44.5H75.5L76 51.2419L75 51.3008L74.5 44.5Z",
    fill: "#E05A50"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.972027,
    y: 121.972,
    width: 142.071,
    height: 59.1282,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.51399,
    result: "effect1_foregroundBlur"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartEmpty);
export default __webpack_public_path__ + "static/media/cart-empty.b0fcfdf8967e498567119013fbfac98b.svg";
export { ForwardRef as ReactComponent };